module.exports = __webpack_public_path__ + "img/leveler-1-on.6f310147.png";